
import { defineComponent, onMounted } from 'vue'
import { useStore } from 'vuex'

export default defineComponent(
{
    name: 'PaySuccess',
    setup()
    {
        // Use vuex:
        const store = useStore()
        // Get authentication status:
        const isAuthenticated = store.getters['auth/isAuthenticated']
        // Get payment result from store:
        const paymentResult = store.getters['basket/getPaymentResult']

        onMounted(() =>
        {
            if(isAuthenticated && paymentResult)
            {
                // Remove from basket as order is fulfilled:
                store.commit('basket/resetBasket')
            }
        })

        // Return data:
        return {
            isAuthenticated,
            paymentResult
        }
    }
})
